import React, { useState } from 'react';

const articles = [
    {
        title: "Understanding Dynamic Programming",
        author: "Jane Doe",
        publishedAt: "2023-09-15",
        summary: "An in-depth look at dynamic programming and how it can be used to solve complex problems efficiently.",
        content: "Dynamic programming is a method for solving complex problems by breaking them down into simpler subproblems...",
        moreInfo: "Dynamic programming is often used in optimization problems, where the goal is to find the best solution among many possibilities. It is particularly useful in problems involving overlapping subproblems and optimal substructure."
    },
    {
        title: "Mastering Graph Algorithms",
        author: "John Smith",
        publishedAt: "2023-08-20",
        summary: "A comprehensive guide to graph algorithms, including BFS, DFS, and Dijkstra's algorithm.",
        content: "Graph algorithms are essential for solving problems related to networks, such as finding the shortest path...",
        moreInfo: "Graph algorithms are widely used in computer science and engineering. They are fundamental in areas such as network routing, social network analysis, and solving puzzles like the shortest path problem."
    },
    {
        title: "Data Structures: Trees and Tries",
        author: "Alice Johnson",
        publishedAt: "2023-07-10",
        summary: "Explore the world of trees and tries, and learn how they can be used to organize and search data efficiently.",
        content: "Trees and tries are fundamental data structures that provide efficient ways to store and retrieve data...",
        moreInfo: "Trees and tries are used in various applications, including databases, file systems, and text processing. They offer efficient search, insert, and delete operations, making them ideal for dynamic datasets."
    },
    {
        title: "Optimizing Code for Competitive Programming",
        author: "Frank Blue",
        publishedAt: "2023-02-20",
        summary: "Tips and tricks for writing efficient code in competitive programming.",
        content: "In competitive programming, writing efficient code is crucial. This article covers various optimization techniques...",
        moreInfo: "Optimizing code involves reducing time complexity, using efficient data structures, and avoiding unnecessary computations. These techniques can significantly improve your performance in competitions."
    },
    {
        title: "Understanding Time Complexity",
        author: "Grace Yellow",
        publishedAt: "2023-01-15",
        summary: "A guide to understanding and analyzing time complexity in algorithms.",
        content: "Time complexity is a measure of the time an algorithm takes to run as a function of the size of its input...",
        moreInfo: "Understanding time complexity helps in selecting the most efficient algorithm for a given problem. It is a fundamental concept in competitive programming."
    },
    {
        title: "Dynamic Programming in Competitive Programming",
        author: "Hank Purple",
        publishedAt: "2022-12-10",
        summary: "Learn how to apply dynamic programming techniques to solve complex problems in competitions.",
        content: "Dynamic programming is a powerful technique used to solve problems by breaking them down into simpler subproblems...",
        moreInfo: "Mastering dynamic programming can give you a significant advantage in competitive programming, as it allows you to solve problems that would be difficult to tackle otherwise."
    },
    {
        title: "Graph Theory for Competitive Programmers",
        author: "Ivy Orange",
        publishedAt: "2022-11-05",
        summary: "An introduction to graph theory and its applications in competitive programming.",
        content: "Graph theory is a branch of mathematics that studies the properties of graphs. In competitive programming, it is used to solve problems related to networks...",
        moreInfo: "Understanding graph theory and algorithms like BFS, DFS, and Dijkstra's can help you solve a wide range of problems in competitive programming."
    },
    {
        title: "Mastering Recursion",
        author: "Jack Red",
        publishedAt: "2022-10-01",
        summary: "A comprehensive guide to understanding and mastering recursion in programming.",
        content: "Recursion is a technique where a function calls itself to solve smaller instances of the same problem...",
        moreInfo: "Recursion is a powerful tool in competitive programming, allowing you to solve problems that can be broken down into smaller, similar subproblems."
    },
    {
        title: "Greedy Algorithms in Competitive Programming",
        author: "Karen Pink",
        publishedAt: "2022-09-15",
        summary: "Learn how to use greedy algorithms to solve optimization problems in competitions.",
        content: "Greedy algorithms make locally optimal choices at each step with the hope of finding a global optimum...",
        moreInfo: "Greedy algorithms are often used in competitive programming for problems where a locally optimal solution leads to a globally optimal solution."
    },
    {
        title: "Backtracking Techniques",
        author: "Leo Brown",
        publishedAt: "2022-08-10",
        summary: "An in-depth look at backtracking techniques and their applications in competitive programming.",
        content: "Backtracking is a technique for solving problems by trying out different possibilities and undoing steps that lead to dead ends...",
        moreInfo: "Backtracking is useful for solving combinatorial problems, such as generating permutations and combinations, and solving puzzles like Sudoku."
    },
    {
        title: "Segment Trees and Their Applications",
        author: "Mona Green",
        publishedAt: "2022-07-05",
        summary: "Explore the concept of segment trees and how they can be used to solve range query problems.",
        content: "Segment trees are data structures that allow efficient querying and updating of array segments...",
        moreInfo: "Segment trees are particularly useful in competitive programming for problems involving range queries and updates, such as finding the sum or minimum of a subarray."
    },
    {
        title: "Fenwick Trees Explained",
        author: "Nina Blue",
        publishedAt: "2022-06-01",
        summary: "A beginner's guide to understanding and using Fenwick trees in competitive programming.",
        content: "Fenwick trees, also known as Binary Indexed Trees (BIT), are data structures that provide efficient methods for cumulative frequency tables...",
        moreInfo: "Fenwick trees are used in competitive programming for problems involving prefix sums and updates, offering a simpler alternative to segment trees."
    },
    {
        title: "Advanced Sorting Techniques",
        author: "Oscar Yellow",
        publishedAt: "2022-05-15",
        summary: "Learn advanced sorting techniques to improve your problem-solving skills in competitions.",
        content: "Sorting is a fundamental operation in competitive programming. This article covers advanced sorting techniques such as quicksort, mergesort, and heapsort...",
        moreInfo: "Mastering advanced sorting techniques can help you solve a variety of problems more efficiently, as many problems require sorted data or involve sorting as a subroutine."
    }
];

const Articles = () => {
    const [expandedArticleIndex, setExpandedArticleIndex] = useState(null);

    const toggleArticle = (index) => {
        setExpandedArticleIndex(expandedArticleIndex === index ? null : index);
    };

    return (
        <div className="p-4">
            {articles.map((article, index) => (
                <div key={index} className="bg-white shadow-md rounded-lg p-6 mb-4">
                    <h2 className="text-2xl font-bold mb-2 cursor-pointer" onClick={() => toggleArticle(index)}>
                        {article.title}
                    </h2>
                    <p className="text-gray-600 mb-2">By {article.author} on {article.publishedAt}</p>
                    <p className="text-gray-800 mb-4">{article.summary}</p>
                    <button 
                        className="text-blue-500 underline mb-4" 
                        onClick={() => toggleArticle(index)}
                    >
                        {expandedArticleIndex === index ? 'Show Less' : 'Read More'}
                    </button>
                    {expandedArticleIndex === index && (
                        <>
                            <p className="text-gray-700 mb-4">{article.content}</p>
                            <p className="text-gray-600">{article.moreInfo}</p>
                        </>
                    )}
                </div>
            ))}
        </div>
    );
};

export default Articles;